import { useState, useEffect } from 'react';

export const useBreakpoint = () => {
  const [screens, setScreens] = useState({
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
  });

  useEffect(() => {
    const getBreakpoints = () => {
      const width = window.innerWidth;
      return {
        xs: width < 576,
        sm: width >= 576 && width < 768,
        md: width >= 768 && width < 992,
        lg: width >= 992 && width < 1200,
        xl: width >= 1200,
      };
    };

    const handleResize = () => {
      setScreens(getBreakpoints());
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screens;
};
